
export const translations = {
  he: {
    nav: {
      home: 'ראשי',
      story: 'הסיפור שלנו',
      menu: 'מה בסיר?',
      gallery: 'אווירה',
      contact: 'איפה ומתי',
      faq: 'שאלות ותשובות',
    },
    home: {
      heroTitle: 'צ\'ולנט יהודה פייט',
      heroSubtitle: 'הטעם של הבית, בלב בני ברק',
      heroCtaMenu: 'לתפריט',
      heroCtaLocation: 'הירקון 39, בני ברק',
      openStatus: 'אנחנו פתוחים!',
      openMsg: 'הסירים חמים, אנחנו מחכים לכם.',
      opensIn: 'הסירים נפתחים בעוד:',
      days: 'ימים',
      hours: 'שעות',
      minutes: 'דקות',
      seconds: 'שניות',
      teaserTitle: 'חוויה של \nמביני עניין',
      teaserText: 'אנחנו לא עוד מסעדה ברחוב. המיקום שלנו ברחוב הירקון 39 מאפשר מקום נקי, שקט ואיכותי. הצ\'ולנט שלנו הוא יצירת אמנות של בישול איטי, נקי מאוד ועם טעם שאי אפשר לחקות. המקום פועל כל יום חמישי מהשעה 13:00 ועד 03:00 לפנות בוקר.',
      teaserOpen: 'פתוח רק בחמישי',
      statsStars: 'דירוג כוכבים',
      statsService: 'יחס אישי',
      favoritesTitle: 'המובחרים של יהודה',
      favCholent: 'הצ\'ולנט המפורסם',
      favCholentSub: 'טעם נקי ועשיר',
      favKugel: 'קוגל ירושלמי',
      favKugelSub: 'מומלץ בחום',
      favKishke: 'יאפצ\'יק עסיסי',
      favKishkeSub: 'השילוב המושלם',
      fullMenuBtn: 'לתפריט המלא',
      reviewsTitle: 'מילים חמות מהלקוחות',
      reviews: [
        { id: 1, name: "ישי מליח", text: "הצ'ולנט הכי טוב בבני ברק, ללא ספק. מנה דשנה, מלאה בטעם ביתי, עם התערובת המושלמת של בשר עדין, שעועית, תפוחי אדמה וקישקע שנמס בפה. האווירה אותנטית, אופיינית לבני ברק: הרבה אנשים, חמימות והארומה הזאת שאפשר להרגיש מהרחוב.", stars: 5 },
        { id: 2, name: "נתי ברקוביץ'", text: "הצ'ולנט הכי טעים שאכלתי, מכירים משהו טוב יותר? תכתבו לי שאוכל לגוון... בינתיים בעלי ואני מדי שבוע מבקרים שם.", stars: 5 },
        { id: 3, name: "משה פרידמן", text: "טשולנט מעולה בכל קנה מידה. בשר ברמה גבוהה ובשפע. יאפצ'וק, קוגל, סלט כבד ועוד כל מיני פינוקים. לחמניות טריות ופחיות קרות... מי צריך יותר מזה? יהודה בעל העסק אדיב וסבלני ברמה מוגזמת, והאווירה מושלמת.", stars: 5 },
        { id: 4, name: "אפרת כהן", text: "הגענו למקום בפעם הראשונה, ראשית נהנינו מהאווירה החמה והביתית, שנית, מרגע התשלום ועד לקבלת האוכל עברו כ-10 דקות, שלישית וההההכי חשוב: הצ'ולנט הכי טעים שאכלתי עד היום! מפוצץ בשר, מרקם מדויק, והוספנו בצד כבד קצוץ וטחינה שבכלל שדרגו את המנה.", stars: 5 },
        { id: 5, name: "ארתור למפרט", text: "לאחר סבב ארצי, זה לגמרי המקום הראשון בטעם ובאיכות! לגמרי אחזור שוב.", stars: 5 },
        { id: 6, name: "אברהם ויגדור", text: "אחלה יהודה שבעולם. הטשולנט הטוב בארץ! למבינים באמת. אחלה טשולנט, אחלה אווירה, והנחה קבועה לבחורי ישיבות.", stars: 5 },
        { id: 7, name: "עדיאל שרעבי", text: "החמין הכי טעים שאכלתי אי פעם. בשר נימוח, קישקע רך, עם טעמים עמוקים... ומקום עם אווירה טובה! מומלץ!!!", stars: 5 },
        { id: 8, name: "דניאל רוקח", text: "חיפשתי הרבה אחרי צ'ולנט איכותי וטעים. טעמתי בהרבה מקומות בבני ברק ובבשלנים אחרים. בסוף הגעתי ליהודה פייט, נהדר, טעים ולא יקר. ממליץ!", stars: 5 }
      ],
      reviewsCount: '4.9 כוכבים מתוך מאות ביקורות',
      finalCtaTitle: 'יום חמישי הגיע?',
      finalCtaText: 'אנחנו מחכים לכם ברחוב הירקון 39.',
      finalCtaBtn: 'נווט אלינו'
    },
    menu: {
      title: 'התפריט',
      subtitle: 'מה בסיר?',
      description: 'כל מנה מוכנת במסירות, עם חומרי גלם איכותיים ומתכונים שעברו מדור לדור.',
      categories: {
        all: 'הכל',
        mains: 'עיקריות',
        sides: 'תוספות וסלטים',
        drinks: 'שתייה'
      },
      items: [
        { id: 'cholent_500', category: 'mains', name: 'צ\'ולנט חצי קילו', description: 'המנה הקלאסית והאהובה.', price: '₪50', bestSeller: true, imageContext: 'cholent' },
        { id: 'cholent_250', category: 'mains', name: 'צ\'ולנט רבע קילו', description: 'מנה אישית מדויקת.', price: '₪32', imageContext: 'cholent' },
        
        { id: 'yapchik_500', category: 'mains', name: 'קוגל יאפצ\'ק חצי קילו', description: 'שילוב מנצח של קוגל ובשר בבישול ארוך.', price: '₪55', bestSeller: true, imageContext: 'meat' },
        { id: 'yapchik_250', category: 'mains', name: 'קוגל יאפצ\'ק רבע קילו', description: 'שילוב מנצח של קוגל ובשר בבישול ארוך.', price: '₪30', imageContext: 'meat' },

        { id: 'liver', category: 'sides', name: 'פטה כבד', description: 'במרקם עשיר וביתי.', price: '₪20', imageContext: 'meat' },
        { id: 'egg_salad', category: 'sides', name: 'סלט ביצים', description: 'ביתי וטרי.', price: '₪10', imageContext: 'general' },
        { id: 'tomato_dip', category: 'sides', name: 'דיפ עגבניות', description: 'מטבל עגבניות פיקנטי.', price: '₪12', imageContext: 'general' },
        { id: 'arbes', category: 'sides', name: 'ארבעס', description: 'גרגירי חומוס מתובלים.', price: '₪10', imageContext: 'general' },
        { id: 'tahini', category: 'sides', name: 'טחינה', description: 'טחינה איכותית.', price: '₪9', imageContext: 'general' },
        { id: 'schug', category: 'sides', name: 'סחוג', description: 'חריף ביתי.', price: '₪15', isSpicy: true, imageContext: 'general' },

        { id: 'kugel_noodle', category: 'sides', name: 'קוגל איטריות', description: 'קלאסיקה ירושלמית מתוקה-חריפה.', price: '₪5', imageContext: 'kugel' },
        { id: 'kugel_potato', category: 'sides', name: 'קוגל תפוח אדמה', description: 'פריך וזהוב.', price: '₪6', imageContext: 'kugel' },
        { id: 'kugel_overnight_500', category: 'sides', name: 'קוגל אוברנייט חצי קילו', description: 'קוגל תפו"א חום עמוק מבישול כל הלילה.', price: '₪30', imageContext: 'kugel' },
        { id: 'kugel_overnight_250', category: 'sides', name: 'קוגל אוברנייט רבע קילו', description: 'קוגל תפו"א חום עמוק מבישול כל הלילה.', price: '₪17', imageContext: 'kugel' },
        { id: 'house_dessert', category: 'sides', name: 'קינוח הבית', description: 'סיום מתוק ומושלם לארוחה.', price: '₪7', imageContext: 'general' },

        { id: 'drink_can', category: 'drinks', name: 'פחיות שתיה', description: 'מגוון טעמים.', price: '₪8', imageContext: 'drinks' },
        { id: 'water', category: 'drinks', name: 'מים', description: 'מינרלים.', price: '₪8', imageContext: 'drinks' },
        { id: 'soda', category: 'drinks', name: 'סודה', description: 'מוגז עדין.', price: '₪8', imageContext: 'drinks' },
        { id: 'bottle_small', category: 'drinks', name: 'בקבוק שתיה קטן', description: 'אישי.', price: '₪9', imageContext: 'drinks' },
        { id: 'bottle_large', category: 'drinks', name: 'בקבוק שתיה גדול', description: 'משפחתי.', price: '₪17', imageContext: 'drinks' },
      ],
      bestSellerLabel: 'הכי נמכר',
      recommendedAddon: 'תוספת מומלצת',
      cta: 'בואו לטעום את ההבדל'
    },
    about: {
      heroTitle: 'מסיר אחד לאגדה',
      heroSubtitle: 'סיפור על אהבה, מסורת ועלייה מטאורית - מהמטבח הביתי ועד ללב הפועם של בני ברק.',
      originTitle: 'איך כבשו את בני ברק ב-',
      originYears: '4 שנים?',
      originText1: 'לפני קצת יותר מארבע שנים בלבד, הכול התחיל מסיר צ’ולנט אחד במטבח הביתי של יהודה פייט. לא הייתה מסעדה, לא שלט, ולא פרסום. היה רק ריח משכר וטעם שאי אפשר היה לשמור בסוד.',
      originText2: 'השמועה עברה מפה לאוזן במהירות. אנשים דפקו בדלת, הסירים התרבו, והמטבח הביתי הפך קטן מדי מלהכיל את האהבה והביקוש.',
      originText3: 'לפני שלוש שנים הבנו שהגיע הזמן לעשות את הצעד הבא, ועברנו למשכננו ברחוב הירקון 39. התחלנו בחנות קטנה, אך גם היא במהרה לא עמדה בעומסים. מתוך רצון לשמור על האיכות, השירות והחוויה שהפכו לסימן ההיכר שלנו, עברנו למשכננו המרווח בקומה השנייה.',
      quote: 'היום אנחנו ממשיכים לבשל באותה אהבה, באותה הקפדה, ועם אותה מטרה: להגיש צ’ולנט אמיתי, ביתי עם הטעם המושלם שרק יהודה יודע לתת, כזה שמרגישים בו את הלב כבר מהכף הראשונה. ומשם? השאר כבר היסטוריה… והריח עוד ממשיך להתפשט.',
      philTitle: 'פילוסופיית המטבח',
      philSubtitle: 'איך מגיעים לטעם כזה בזמן כל כך קצר? התשובה נמצאת בפרטים הקטנים.',
      details: [
        { title: 'הבשרים המובחרים', text: 'אנחנו לא מתפשרים על הנתחים. כל נתח בשר נבחר בקפידה כדי להבטיח רכות מקסימלית ועסיסיות שמעשירה את כל התבשיל בטעמי עומק.' },
        { title: 'זמן הוא המרכיב הסודי', text: 'הסירים שלנו יושבים על האש שעות ארוכות. אין קיצורי דרך. הבישול האיטי מאפשר לטעמים להתמזג ולהפוך למרקם הסמיך והמפורסם שלנו.' },
        { title: 'ניקיון לפני הכל', text: 'הביקורות לא משקרות. המטבח שלנו מצוחצח, חומרי הגלם נשטפים וממויינים בקפדנות יתרה. טעם נקי מתחיל במטבח נקי.' }
      ],
      awardQuote: '"תוך 3 שנים הפכנו לתחנת חובה לכל חובב צ\'ולנט בישראל."',
      valuesTitle: 'למה דווקא אצלנו?',
      values: [
        { title: 'אווירת בוטיק', text: 'הניתוק מהרחוב הסואן יוצר אווירה רגועה ומכובדת. מקום שכיף לשבת בו, לא רק "לחטוף" מנה.' },
        { title: 'נגישות ונוחות', text: 'המקום נגיש (יש מעלית) וממוזג, כך שתוכלו ליהנות מהאוכל בנוחות מקסימלית.' },
        { title: 'האירוח של יהודה', text: 'כשאתם מגיעים, אתם אורחים אישיים שלנו. החיוך והשפע הם חלק מהמנה.' },
        { title: 'חמישי הגדול', text: 'החגיגה מתחילה ב-13:00 ונמשכת עד 03:00 לפנות בוקר. לילה שלם של טעמים.' }
      ],
      imageLabelTime: 'לפני 4 שנים',
      imageLabelText: 'הכל התחיל בסיר אחד'
    },
    gallery: {
      subtitle: 'האווירה',
      title: 'ליל שישי',
      description: 'כשהשמש שוקעת, הקסם מתחיל. אנשים מגיעים מכל הארץ לחוות את הטעם של השבת.',
      splitTitle: 'המפגש של',
      splitTitleHighlight: 'ליל שישי',
      splitText: 'בליל שישי, הרחוב מתעורר לחיים. התור הארוך לצ\'ולנט של יהודה הפך למסורת – מקום שבו אנשים נפגשים, משוחחים, וטועמים את הטעם האמיתי של השבת.',
      imgTag: 'VIBE',
      imgQuote: '"אין עוד מקום כזה בבני ברק."',
      features: [
        { title: 'אל תוך הלילה', text: 'פתוח עד 03:00' },
        { title: 'מקום מפגש', text: 'כולם מגיעים לכאן' },
        { title: 'שירות אישי', text: 'חיוך עם כל מנה' }
      ],
      gridTitle: 'רגעים מהמקום',
      videoTitle: 'מדברים עלינו',
      videoSubtitle: 'צפו במה שיש לרשת להגיד',
      instagram: 'INSTAGRAM @YEHUDA_FAIT',
      images: [
        { id: 1, alt: 'אווירה שקטה בקומה 2', url: '/images/atmosphere-interior.jpg' },
        { id: 2, alt: 'הסירים של יהודה', url: '/images/hero-cholent.jpg' },
        { id: 3, alt: 'ליל שישי', url: '/images/quiet-corner.jpg' },
        { id: 4, alt: 'הגשה מכל הלב', url: '/images/cholent-plate.jpg' },
      ]
    },
    contact: {
      subtitle: 'בואו לטעום',
      title: 'איפה ומתי',
      addressTitle: 'כתובת',
      addressText: 'רחוב הירקון 39, בני ברק',
      floor: 'קומה 2 (יש מעלית)',
      waze: 'נווט עם Waze',
      hoursTitle: 'שעות פעילות',
      openDay: 'יום חמישי',
      openHours: '13:00 - 03:00 (לפנות בוקר)',
      phoneTitle: 'טלפון',
      quietCorner: 'פינה שקטה בלב העיר',
      quietText: 'המקום שקט, נקי וממוזג. בואו לטעום ולהנות מאווירה אחרת.',
      callBtn: 'חייג להזמנות'
    },
    faq: {
      title: 'שאלות ותשובות',
      subtitle: 'כל מה שרציתם לדעת',
      kosherTitle: 'כשרות למהדרין',
      kosherBadgeMain: 'בהשגחת הרב מרדכי גרוס',
      kosherBadgeSub: 'גאב"ד חניכי הישיבות',
      items: [
        { q: 'מה הכשרות במקום?', a: 'המקום עומד תחת ההשגחה המהודרת של הגאון הרב מרדכי גרוס שליט"א, גאב"ד "חניכי הישיבות". כל המוצרים והבשרים הם בכשרות המהודרת ביותר ללא פשרות.' },
        { q: 'האם המקום פתוח בימים אחרים?', a: 'כרגע הפעילות שלנו מתמקדת בלילות חמישי בלבד, החל מהשעה 13:00 בצהריים ועד 03:00 לפנות בוקר (או עד גמר הסירים...).' },
        { q: 'האם יש מקום לשבת?', a: 'בוודאי! בניגוד למקומות אחרים, אנחנו ממוקמים בקומה השנייה באולם ממוזג, נקי ומרווח עם שולחנות וכסאות, כך שאפשר לאכול בנחת.' },
        { q: 'האם עושים משלוחים?', a: 'כרגע אין שירות משלוחים קבוע. המטרה שלנו היא שתבואו לחוות את האווירה והטריות במקום. להזמנות גדולות מיוחדות ניתן ליצור קשר טלפוני.' },
        { q: 'האם ניתן לשלם באשראי?', a: 'כן, אנו מכבדים מזומן ואשראי.' },
        { q: 'האם יש חניה באזור?', a: 'בשעות הלילה המאוחרות של יום חמישי בדרך כלל ניתן למצוא חניה ברחובות הסמוכים, אך מומלץ להגיע מוקדם או להחנות בחניונים באזור.' }
      ]
    },
    footer: {
      tagline: 'כשהמסורת פוגשת את הלילה',
      rights: 'כל הזכויות שמורות.',
      kosherMain: 'כשר למהדרין',
      kosherRabbi: 'הרב מרדכי גרוס',
      kosherOrg: 'גאב"ד חניכי הישיבות',
      accessibility: 'הצהרת נגישות'
    }
  },
  en: {
    nav: {
      home: 'Home',
      story: 'Our Story',
      menu: 'Menu',
      gallery: 'Vibe',
      contact: 'Location',
      faq: 'FAQ',
    },
    home: {
      heroTitle: 'Cholent Yehuda Fait',
      heroSubtitle: 'The Taste of Home, Heart of Bnei Brak',
      heroCtaMenu: 'Our Menu',
      heroCtaLocation: '39 HaYarkon St',
      openStatus: 'We Are Open!',
      openMsg: 'The pots are hot, waiting for you.',
      opensIn: 'Opening in:',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Mins',
      seconds: 'Secs',
      teaserTitle: 'A Connoisseur\'s \nExperience',
      teaserText: 'We are not just another street food spot. Located on 39 HaYarkon St, we offer a clean, quiet, and high-quality venue. Our Cholent is a work of slow-cooking art, extremely clean with an inimitable taste. Open every Thursday from 1:00 PM until 3:00 AM.',
      teaserOpen: 'Open Thursdays Only',
      statsStars: 'Star Rating',
      statsService: 'Personal Service',
      favoritesTitle: 'Yehuda\'s Favorites',
      favCholent: 'Famous Cholent',
      favCholentSub: 'Clean & Rich Taste',
      favKugel: 'Jerusalem Kugel',
      favKugelSub: 'Highly Recommended',
      favKishke: 'Yapchik',
      favKishkeSub: 'Perfect Combo',
      fullMenuBtn: 'Full Menu',
      reviewsTitle: 'Warm Words from Customers',
      reviews: [
        { id: 1, name: "Ishay Maleh", text: "The best Cholent in Bnei Brak, without a doubt. Generous portion, full of homemade taste, tender meat, beans, potatoes and melt in your mouth kishke. Authentic atmosphere.", stars: 5 },
        { id: 2, name: "Nati Berkowitz", text: "The tastiest Cholent I have ever had. My husband and I visit every single week.", stars: 5 },
        { id: 3, name: "Moshe Friedman", text: "Excellent Cholent by any standard. Top quality meat in abundance. Yapchik, kugel, liver salad and cool drinks. Yehuda the owner is exceedingly gracious and kind.", stars: 5 },
        { id: 4, name: "Efrat Cohen", text: "First time here! We enjoyed the warm atmosphere, fast service, and above all, the best Cholent I've ever tasted! Loaded with meat, precise texture.", stars: 5 },
        { id: 5, name: "Arthur Lampert", text: "After a nationwide tour, this is absolutely #1 in taste and quality! Will definitely return.", stars: 5 },
        { id: 6, name: "Avraham Vigdor", text: "Legendary Yehuda! The best Cholent in the country for true connoisseurs. Great vibe and discount for yeshiva students.", stars: 5 },
        { id: 7, name: "Adiel Sharabi", text: "The most delicious Cholent I ever ate. Tender meat, soft kishke, deep flavors and awesome vibe. Highly recommended!", stars: 5 },
        { id: 8, name: "Daniel Rokach", text: "Searched long for quality Cholent in Bnei Brak. Finally found Yehuda Fait, wonderful, delicious and fairly priced. Recommended!", stars: 5 }
      ],
      reviewsCount: '4.9 Stars from hundreds of reviews',
      finalCtaTitle: 'Is it Thursday yet?',
      finalCtaText: 'We are waiting for you at 39 HaYarkon St.',
      finalCtaBtn: 'Navigate Now'
    },
    menu: {
      title: 'The Menu',
      subtitle: 'What\'s in the Pot?',
      description: 'Every dish is prepared with dedication, quality ingredients, and recipes passed down through generations.',
      categories: {
        all: 'All',
        mains: 'Mains',
        sides: 'Sides & Salads',
        drinks: 'Drinks'
      },
      items: [
        { id: 'cholent_500', category: 'mains', name: 'Meat Cholent (0.5kg)', description: 'The classic beloved dish.', price: '₪50', bestSeller: true, imageContext: 'cholent' },
        { id: 'cholent_250', category: 'mains', name: 'Meat Cholent (0.25kg)', description: 'Precise personal portion.', price: '₪32', imageContext: 'cholent' },
        
        { id: 'yapchik_500', category: 'mains', name: 'Yapchik (0.5kg)', description: 'Winning combination of potato kugel and slow-cooked meat.', price: '₪55', bestSeller: true, imageContext: 'meat' },
        { id: 'yapchik_250', category: 'mains', name: 'Yapchik (0.25kg)', description: 'Winning combination of potato kugel and slow-cooked meat.', price: '₪30', imageContext: 'meat' },

        { id: 'liver', category: 'sides', name: 'Liver Pâté', description: 'Rich, home-style texture.', price: '₪20', imageContext: 'meat' },
        { id: 'egg_salad', category: 'sides', name: 'Egg Salad', description: 'Fresh and homemade.', price: '₪10', imageContext: 'general' },
        { id: 'tomato_dip', category: 'sides', name: 'Tomato Dip', description: 'Spicy tomato dip.', price: '₪12', imageContext: 'general' },
        { id: 'arbes', category: 'sides', name: 'Arbes (Chickpeas)', description: 'Seasoned chickpeas.', price: '₪10', imageContext: 'general' },
        { id: 'tahini', category: 'sides', name: 'Tahini', description: 'Quality Tahini.', price: '₪9', imageContext: 'general' },
        { id: 'schug', category: 'sides', name: 'Schug', description: 'Homemade spicy dip.', price: '₪15', isSpicy: true, imageContext: 'general' },

        { id: 'kugel_noodle', category: 'sides', name: 'Noodle Kugel', description: 'Jerusalem classic, sweet & peppery.', price: '₪5', imageContext: 'kugel' },
        { id: 'kugel_potato', category: 'sides', name: 'Potato Kugel', description: 'Crispy and golden.', price: '₪6', imageContext: 'kugel' },
        { id: 'kugel_overnight_500', category: 'sides', name: 'Overnight Kugel (0.5kg)', description: 'Deep brown potato kugel slow-cooked all night.', price: '₪30', imageContext: 'kugel' },
        { id: 'kugel_overnight_250', category: 'sides', name: 'Overnight Kugel (0.25kg)', description: 'Deep brown potato kugel slow-cooked all night.', price: '₪17', imageContext: 'kugel' },
        { id: 'house_dessert', category: 'sides', name: 'House Dessert', description: 'A sweet and perfect ending to the meal.', price: '₪7', imageContext: 'general' },

        { id: 'drink_can', category: 'drinks', name: 'Soft Drinks (Can)', description: 'Various flavors.', price: '₪8', imageContext: 'drinks' },
        { id: 'water', category: 'drinks', name: 'Mineral Water', description: 'Cold.', price: '₪8', imageContext: 'drinks' },
        { id: 'soda', category: 'drinks', name: 'Soda Water', description: 'Lightly sparkling.', price: '₪8', imageContext: 'drinks' },
        { id: 'bottle_small', category: 'drinks', name: 'Small Bottle', description: 'Personal size.', price: '₪9', imageContext: 'drinks' },
        { id: 'bottle_large', category: 'drinks', name: 'Large Bottle', description: 'Family size.', price: '₪17', imageContext: 'drinks' },
      ],
      bestSellerLabel: 'Best Seller',
      recommendedAddon: 'Recommended Add-on',
      cta: 'Come Taste the Difference'
    },
    about: {
      heroTitle: 'From One Pot to Legend',
      heroSubtitle: 'A story of love, tradition, and meteoric rise - from a home kitchen to the beating heart of Bnei Brak.',
      originTitle: 'Conquering Bnei Brak in',
      originYears: '4 Years',
      originText1: 'Just four years ago, Yehuda Fait put one pot of Cholent in his home kitchen. No restaurant, no sign, no ads. Just an intoxicating smell and a taste that couldn\'t be kept secret.',
      originText2: 'Word spread like wildfire. People knocked on the door, pots doubled, and the home kitchen became too small to contain the love the public poured in.',
      originText3: 'Three years ago, we realized we couldn\'t stay home, and moved to our current location - 39 HaYarkon St. We chose the second floor specifically to preserve the homey, intimate, and clean feeling that defined us from day one.',
      quote: '"Our secret is that we don\'t try to be industrial. We cook for large quantities, but with the attention of a single pot."',
      philTitle: 'Kitchen Philosophy',
      philSubtitle: 'How do we reach such taste in such short time? The answer is in the small details.',
      details: [
        { title: 'Premium Meats', text: 'We don\'t compromise on cuts. Every piece is carefully chosen to ensure maximum softness and juiciness that enriches the whole stew.' },
        { title: 'Time is the Secret Ingredient', text: 'Our pots sit on the fire for long hours. No shortcuts. Slow cooking allows flavors to merge into our famous thick texture.' },
        { title: 'Cleanliness First', text: 'Reviews don\'t lie. Our kitchen is spotless, ingredients are washed and sorted meticulously. Clean taste starts in a clean kitchen.' }
      ],
      awardQuote: '"In 3 years we became a must-stop for every Cholent lover in Israel."',
      valuesTitle: 'Why Choose Us?',
      values: [
        { title: 'Boutique Atmosphere', text: 'Detachment from the busy street creates a calm, dignified vibe. A place fun to sit in, not just "grab" food.' },
        { title: 'Accessibility & Comfort', text: 'The place is accessible (elevator available) and air-conditioned, so you can enjoy food in maximum comfort.' },
        { title: 'Yehuda\'s Hospitality', text: 'When you arrive, you are our personal guests. The smile and abundance are part of the dish.' },
        { title: 'The Big Thursday', text: 'The celebration starts at 1:00 PM and lasts until 3:00 AM. A whole night of flavors.' }
      ],
      imageLabelTime: '4 Years Ago',
      imageLabelText: 'It started with one pot'
    },
    gallery: {
      subtitle: 'The Vibe',
      title: 'Thursday Night',
      description: 'When the sun sets, the magic begins. People arrive from all over the country to experience the taste of Shabbat.',
      splitTitle: 'The Gathering of',
      splitTitleHighlight: 'Leil Shishi',
      splitText: 'Every Thursday night, the street comes alive. The long line for Yehuda\'s Cholent has become a tradition – a place where people meet, talk, and taste the real flavor of Shabbat.',
      imgTag: 'VIBE',
      imgQuote: '"No other place like this in Bnei Brak."',
      features: [
        { title: 'Into the Night', text: 'Open until 03:00' },
        { title: 'Meeting Place', text: 'Everyone comes here' },
        { title: 'Personal Service', text: 'A smile with every dish' }
      ],
      gridTitle: 'Moments',
      videoTitle: 'In The Media',
      videoSubtitle: 'Watch what people say',
      instagram: 'INSTAGRAM @YEHUDA_FAIT',
      images: [
        { id: 1, alt: 'Quiet vibe on 2nd floor', url: '/images/atmosphere-interior.jpg' },
        { id: 2, alt: 'Yehuda\'s Pots', url: '/images/hero-cholent.jpg' },
        { id: 3, alt: 'Thursday Night', url: '/images/quiet-corner.jpg' },
        { id: 4, alt: 'Served with Heart', url: '/images/cholent-plate.jpg' },
      ]
    },
    contact: {
      subtitle: 'Come Taste',
      title: 'Location & Hours',
      addressTitle: 'Address',
      addressText: '39 HaYarkon St, Bnei Brak',
      floor: '2nd Floor (Elevator available)',
      waze: 'Navigate with Waze',
      hoursTitle: 'Opening Hours',
      openDay: 'Thursday',
      openHours: '13:00 - 03:00 (AM)',
      phoneTitle: 'Phone',
      quietCorner: 'Quiet Corner in the City',
      quietText: 'Quiet, clean, and air-conditioned. Come taste and enjoy a different atmosphere.',
      callBtn: 'Call for Orders'
    },
    faq: {
      title: 'FAQ',
      subtitle: 'Everything You Needed to Know',
      kosherTitle: 'Strictly Kosher (Mehadrin)',
      kosherBadgeMain: 'Under the Supervision of Rabbi Mordechai Gross',
      kosherBadgeSub: 'Ga\'avad Chanichei HaYeshivot',
      items: [
        { q: 'What is the Kashrus?', a: 'The place is under the strict supervision (Mehadrin) of Rabbi Mordechai Gross, Ga\'avad "Chanichei HaYeshivot". All products and meats are of the highest standard.' },
        { q: 'Are you open other days?', a: 'Currently, we are open only on Thursday nights, from 1:00 PM until 3:00 AM (or until pots are empty).' },
        { q: 'Is there seating?', a: 'Yes! Unlike other spots, we are located on the 2nd floor in an air-conditioned, clean, and spacious hall with tables and chairs.' },
        { q: 'Do you deliver?', a: 'We do not have a regular delivery service. Our goal is for you to come and experience the atmosphere. For large special orders, please call us.' },
        { q: 'Do you accept credit cards?', a: 'Yes, we accept both cash and credit cards.' },
        { q: 'Is there parking?', a: 'Late on Thursday nights, you can usually find parking in nearby streets, but we recommend arriving early or using nearby parking lots.' }
      ]
    },
    footer: {
      tagline: 'When Tradition Meets the Night',
      rights: 'All rights reserved.',
      kosherMain: 'Kosher LeMehadrin',
      kosherRabbi: 'Rabbi Mordechai Gross',
      kosherOrg: 'Ga\'avad Chanichei HaYeshivot',
      accessibility: 'Accessibility Statement'
    }
  }
};
